<template>
    <div>
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="300px">
                <v-card>
                    <v-card-title>
                        <span class="headline">
                            {{ title }}
                        </span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-form
                                ref="form"
                                lazy-validation>
                                    <v-text-field 
                                        :label="$vuetify.lang.t('$vuetify.userManage.role.table.name')" 
                                        v-model="data.name"
                                        :rules="rules.name" 
                                        @change="data.name=formSpaces(data.name)"
                                        dense
                                        required
                                        outlined
                                    ></v-text-field>
                                    <v-treeview
                                        dense
                                        required
                                        outlined
                                        selectable
                                        :items="privileges"
                                        item-key="id"
                                        item-text="name"
                                        v-model="select"
                                        :selection-type="type"
                                    ></v-treeview>
                            </v-form>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="handleClose" :loading="statusModel">
                            {{$vuetify.lang.t('$vuetify.userManage.close')}}
                        </v-btn>
                        <v-btn color="primary" @click="handleUpdate" :loading="statusModel || loading">
                            {{$vuetify.lang.t('$vuetify.userManage.update')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import * as api from '../../../api'
import { Notification } from 'element-ui';

export default {

    props: {
        privileges: Array
    },

    data () {
        return {

            title: this.$vuetify.lang.t('$vuetify.userManage.role.editBtn'),

            dialog: false,

            statusModel: false,

            loading: false,

            type: 'leaf',

            select: [],

            data: {
                name: null,
                groupName: null,
                groupID: null,
                privileges: null
            },

            rules: {
                name: [
                    value => this.formSpaces(value)!='' || this.$vuetify.lang.t('$vuetify.userManage.role.rules.name'),
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.userManage.role.rules.name')
                ],
                groupID: [
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.userManage.role.rules.groupID')
                ]
            }
            
        }
    },  

    methods: {
        formSpaces(str){
            if(str !== null && str !== undefined){
                let res = str.replace(/\s*/g,'')
                return res;
            }
        },
        getDetail (id) {
            this.statusModel = true;
            var url = api.default.rbac.roleDetailUrl + '?id=' + id;
            this.$http.get(url).then(resp => {
                // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                if (!resp) return;
                this.data = resp.data;
                this.data.id = id;
                this.setPrivileges(resp.data.privileges);
            }).finally(resp => {
                this.statusModel = false;
            })
        },

        setPrivileges (value) {
            this.select = []
            var n = value.length;
            for (var i = 0; i < n; i++) {
                this.select.push(value[i].id);
            }
        },

        handleOpen (item) {
            this.getDetail(item.id);
            this.dialog = true;
        },

        handleClose () {
            this.dialog = false;
            this.$refs.form.reset();
        },

        handleUpdate () {
            if (this.$refs.form.validate()) {
                this.loading = true;
                this.data.privileges = this.select;
                this.$http.post(api.default.rbac.roleEditUrl, this.data).then(resp => {
                    // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                    if (!resp) return;
                    Notification({
                        type: 'success',
                        message: this.$vuetify.lang.t('$vuetify.userManage.success')
                    });
                    this.$emit('handleSearch');
                }).finally(resp => {
                    this.loading = false;
                    this.handleClose();
                })
            }
        }

    }
}
</script>

<style scoped>



</style>